/**
 * WB4 Depth — Role-scoped action visibility for list · context · detail surfaces.
 * Inspector quickActions remain preset-driven (RowInspectorT0).
 */

import type { WorkbenchAction } from './action-types';
import type { WorkbenchRole } from './workbench-role-cockpit-config';

/** Per-role action ids hidden from unified resolveWorkbenchActions surfaces. */
export const ROLE_HIDDEN_KERNEL_ACTION_IDS: Readonly<Record<WorkbenchRole, readonly string[]>> = {
  sales: ['start_accounting_workflow', 'start_inventory_workflow', 'start_production_workflow'],
  finance: ['start_order_workflow', 'start_inventory_workflow', 'start_production_workflow'],
  warehouse: ['start_order_workflow', 'start_accounting_workflow', 'start_production_workflow'],
  admin: ['start_order_workflow', 'start_inventory_workflow', 'start_production_workflow'],
  operations: ['start_accounting_workflow'],
  owner: [],
};

export function filterWorkbenchActionsForRole<T extends WorkbenchAction>(
  actions: readonly T[],
  workbenchRole: WorkbenchRole
): T[] {
  const hidden = new Set(ROLE_HIDDEN_KERNEL_ACTION_IDS[workbenchRole] ?? []);
  if (hidden.size === 0) {
    return [...actions];
  }
  return actions.filter((action) => !hidden.has(action.id));
}
